import React, { FC } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { parse } from 'query-string'
import { useSelector } from 'react-redux'
import { FormStateType } from '../../../types'
import { Form, Grid, Button } from '../../System'
import ROUTES from '../../utils/routes'
import { SubscriptionOption, SubscriptionSelect } from '../../Auth/SubscriptionSelect'
import { TRIAL } from '../../utils/stripePrices'
import { AppState } from '../../../redux/root-reducer'
import { AffiliateTrackState } from '../../../redux/affiliate-track/types'
import { useSubscriptions } from '../../Auth'

type Props = {
  form: FormStateType;
  nextStep: () => void;
}

const SubscriptionStep: FC<Props> = ({ form, nextStep }) => {
  const { affiliate } = useSelector<AppState, AffiliateTrackState>((state) => state.affiliate)
  const { values, setValue } = form
  const { subscriptions } = useSubscriptions(!!affiliate)
  const freeTrialInfo = subscriptions.find((subscription) => subscription?.id === TRIAL)

  const { search } = useLocation()
  const queriesFromURL = parse(search, { parseBooleans: true })
  const showTrialOption = !queriesFromURL.hide

  return (
    <Form>
      <Grid inLayout gap={12}>
        <span className="sign-up-cta">
          {showTrialOption
            ? 'Skip the Free Trial and subscribe to get:'
            : 'Choose your subscription'}
        </span>
        <SubscriptionSelect
          subscriptionList={subscriptions}
          value={values.subscription}
          onChange={(value) => setValue('subscription', value)}
        />
        {showTrialOption && freeTrialInfo && (
          <SubscriptionOption
            subscription={freeTrialInfo}
            onChange={() => setValue('subscription', freeTrialInfo)}
            isSelected={values?.subscription?.id === freeTrialInfo.id}
            key={freeTrialInfo?.id}
            isTrial
          />
        )}
      </Grid>
      <Button
        isDisabled={!values.subscription}
        type="large"
        className="continue-btn"
        onClick={() => nextStep()}
      >
        {values?.subscription?.id === TRIAL ? 'START FREE TRIAL' : 'CONTINUE'}
      </Button>
      <span className="auth-prompt">
        Already have an account? <Link to={ROUTES.user.login}>Sign In</Link>
      </span>
    </Form>
  )
}

export default SubscriptionStep
